import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  user: false, // Initially set to false
  user_data: null, // Added this to handle the user data
};

// Create a slice for user authentication
const fotogritSlice = createSlice({
  name: 'fotogrit',
  initialState,
  reducers: {
    // Handle user authentication
    userAuthTrue: (state, action) => {
      state.user = action.payload.user;
      state.user_data = action.payload.user_data;
    },

    // Handle user log out
    userLogout: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// Export the actions generated by createSlice
export const { userAuthTrue, userLogout } = fotogritSlice.actions;

// Export the reducer
export default fotogritSlice.reducer;
